import SnaploaderView from './snaploader-view'

export default SnaploaderView
